import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { fetchMarkdown } from '../utils/markdownLoader';

const DEFAULT_CLASSNAME = 'container-1200 container-up container-hd';

const MarkdownPage = ({ slug, fallback, className = DEFAULT_CLASSNAME }) => {
  const [status, setStatus] = useState('loading');
  const [markdown, setMarkdown] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    let cancelled = false;

    fetchMarkdown(slug, { signal: controller.signal })
      .then((text) => {
        if (cancelled) return;
        setMarkdown(text);
        setStatus('ready');
      })
      .catch((err) => {
        if (cancelled || err.name === 'AbortError') return;
        console.warn(`MarkdownPage(${slug}): falling back —`, err.message);
        setStatus('error');
      });

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [slug]);

  if (status !== 'ready') {
    return fallback;
  }

  return (
    <div className={className}>
      <div className="markdown-content">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            a: ({ node, href, children, ...props }) => (
              <a
                href={href}
                target={href && href.startsWith('http') ? '_blank' : undefined}
                rel={href && href.startsWith('http') ? 'noopener noreferrer' : undefined}
                {...props}
              >
                {children}
              </a>
            ),
          }}
        >
          {markdown}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default MarkdownPage;
